import { render, staticRenderFns } from "./UFField.vue?vue&type=template&id=34996c55"
import script from "./UFField.vue?vue&type=script&lang=js"
export * from "./UFField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports